/*
 * File: cc-grid-selector.component.ts                                         *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PageService } from '../../../services/page.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'app/modules/catalog-cloud/services/product.service';
import { CellService } from 'app/modules/catalog-cloud/services/cell.service';
import { Cell, PageTemplate } from '@nousmedis/cc-types';
@Component({
  selector: 'app-cc-grid-selector',
  templateUrl: './cc-grid-selector.component.html',
  styleUrls: ['./cc-grid-selector.component.scss']
})
export class CcGridSelectorComponent implements OnInit {


  @Input() grids: PageTemplate[];
  @Input() currentGrid: PageTemplate;
  @Input() lock: boolean = true;
  @Input() pageId: string;
  @Output() locked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() newGridFormat: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveFormat: EventEmitter<boolean> = new EventEmitter<boolean>();

  lockIcon: string = 'fa fa-lock';
  lockedIcon: string = 'fa fa-lock';
  unlockedIcon: string = 'fa fa-lock-open';

  lockedSeverity: string = 'success';
  unlockedSeverity: string = 'danger';
  lockSeverity: string = 'success';

  cancelIcon: string = 'fa fa-trash';
  selectedGrid: PageTemplate;
  backupCurrentGrid: PageTemplate;
  gridTemplateItems: any = [];

  backupCells: Cell[] = [];


  constructor (private pageService: PageService,
    private confirmService: ConfirmationService,
    private translateService: TranslateService,
    private productService: ProductService,
    private cellService: CellService

  ) { }

  ngOnInit(): void {
    this.orderGridList();
    this.fillListItems();
    this.lockIcon = this.lock ? this.lockedIcon : this.unlockedIcon;
    this.selectedGrid = this.currentGrid;
    this.backupCurrentGrid = JSON.parse(JSON.stringify(this.currentGrid));

  }

  fillListItems() {
    this.gridTemplateItems = [];
    this.grids.forEach(grid => {
      this.gridTemplateItems.push({ label: grid.name, value: grid.id, command: () => this.changeFormat(grid.id) });
    });
  }

  orderGridList() {
    this.grids = this.grids.sort(function (a, b) {
      let nameA = a.name;
      let nameB = b.name;
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  }

  toggleEditor() {
    this.lockIcon = this.lock ? this.lockedIcon : this.unlockedIcon;
    this.lockSeverity = this.lock ? this.lockedSeverity : this.unlockedSeverity;
    this.locked.emit(this.lock);

  }

  toggle() {
    //Al hacer lock en celdas, se genera un backup y se hace un toggle
    if (this.lock) {
      this.lock = false;
      this.backupCells = JSON.parse(JSON.stringify(this.pageService.pages.find(p => p.id == this.pageId).cells));
      this.toggleEditor();
    }
    //Si se hace un unlock, se comprueba si las celdas han cambiado
    else {
      this.lock = true;
      const currentCells = this.pageService.pages.find(p => p.id == this.pageId).cells;
      //alert("Total Backup Cells: " + this.backupCells.length + " Total Current Cells: " + currentCells.length);  ;
      if (this.sameCells(this.backupCells, currentCells)) {
        //alert("No se han realizado cambios en la cuadrícula");
        this.save();
        this.toggleEditor();
      }
      else {
        this.confirmService.confirm({
          header: this.translateService.instant('PAGE.EDIT_PAGE_FORMAT'),
          message: this.translateService.instant('PAGE.EDIT_PAGE_FORMAT_MESSAGE'),
          icon: 'pi pi-exclamation-circle',
          rejectLabel: this.translateService.instant('FORM.NO'),
          acceptLabel: this.translateService.instant('FORM.YES'),
          accept: () => {
            for (let i = 0; i < this.backupCells.length; i++) {
              if (this.backupCells[i].product && this.backupCells[i].product != null) {
                this.productService.removeProduct$.next(this.backupCells[i].product.id);
                //this.cellService.cleanCell.next(currentCells[i].id);
              }
            }
            
            this.save();
            this.toggleEditor();
            this.productService.refreshProducts$.next();

          },
          reject: () => {
            this.toggleEditor();
            this.cancel();

          }
        });
      }

      // this.save();
      // this.toggleEditor();

    }
  }

  hasProducts(cells: Cell[]) {
    return cells.filter(p => p.product != null).length > 0;
  }


  sameCells(oldCells: Cell[], newCells: Cell[]) {
    if (oldCells.length !== newCells.length) return false;
    return oldCells.every((old, i) => {
      const curr = newCells[i];
      return old.visible === curr.visible
        && old.columnWith === curr.columnWith
        && old.rowWidth === curr.rowWidth;
    });
  }

  save() {
    this.saveFormat.emit(true);
  }

  cancel() {
    this.backupCurrentGrid.cells = this.backupCells;
    this.selectedGrid = JSON.parse(JSON.stringify(this.backupCurrentGrid));
    this.currentGrid = JSON.parse(JSON.stringify(this.backupCurrentGrid));

    console.log("Cell 0", this.backupCurrentGrid.cells[0]);

    this.newGridFormat.emit(this.backupCurrentGrid);
    this.saveFormat.emit(false);
  }

  changeFormat(idGrid: any) {
    let grid = this.grids.filter(f => { return f['id'] === idGrid; })[0];
    this.newGridFormat.emit(grid);
  }

  confirmRemovePage(event: Event, pageId: string) {
    this.confirmService.confirm({
      target: event.target as EventTarget,
      message: this.translateService.instant('PAGE.DELETE_QUESTION'),
      header: this.translateService.instant('PAGE.DELETE'),
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptLabel: this.translateService.instant('FORM.YES'),
      rejectLabel: this.translateService.instant('FORM.NO'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const products = this.pageService.pages.find(p => p.id == pageId).cells?.map(c => c.product);
        this.pageService.removePage(pageId).then(() => {
          for (let prod of products) {
            //Si existe producto en la celda, se elimina
            if (prod) this.productService.removeProduct$.next(prod.id);
          }
          this.confirmService.close();
        });

      },
      reject: () => {
        // Nothing
        this.confirmService.close();
      }
    });
  }


}
